const EXTENSION_TO_MIME_TYPES: Record<string, readonly string[]> = {
  '.svg': ['image/svg+xml'],
  '.png': ['image/png', 'image/x-png'],
  '.jpg': ['image/jpeg', 'image/jpg', 'image/pjpeg'],
  '.jpeg': ['image/jpeg', 'image/jpg', 'image/pjpeg'],
  '.gif': ['image/gif'],
  '.webp': ['image/webp'],
  '.bmp': ['image/bmp'],
  '.pdf': ['application/pdf'],
  '.csv': ['text/csv'],
};

export const getFileExtension = (fileName: string): string => {
  const lastDot = fileName.lastIndexOf('.');
  if (lastDot <= 0) return '';
  return fileName.slice(lastDot).toLowerCase();
};

export const isAcceptedFileType = (file: File, acceptedFileTypes: string[]): boolean => {
  const extension = getFileExtension(file.name);
  if (!extension || !acceptedFileTypes.includes(extension)) return false;

  const allowedMimeTypes = EXTENSION_TO_MIME_TYPES[extension];
  if (file.type && allowedMimeTypes && !allowedMimeTypes.includes(file.type)) return false;

  return true;
};
